import React, { useContext, useEffect, useState }  from 'react';
import { Button, Card, Form, Input, Modal, notification, Skeleton } from "antd";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { detailsColumn } from './columns';
import { downloadCSV, encrypt, formatDate, getUserRole } from '../../services/util';
import { SettingContext } from '../../routes';
import { useLocation, useParams } from 'react-router-dom';

const CallLogDetails = () => {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const lcoationParams = useParams();
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [tableData, setTableData] = useState([]);
    const [buttonStatus, setButtonStatus] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [passwordModalVisible, setPasswordModalVisible] = useState(false);
    const [guestDeatilsModalVisible, setGuestDetailsModalVisible] =
        useState(false);
    const [selectedCallId, setSelectedCallId] = useState("");

    const hotel_ids = [Number(lcoationParams.hotel_id)];

    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
    });

    const [guestDetails, setGuestDetails] = useState({});
    const {
        status: callLogStatus,
        data: callLogRes,
        refetch: getCallLog,
    } = useQuery(
        "/call-log",
        async () => {
            return await HTTP("/dashboard/getCallLogsDetails", { ...formData });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getCallLog();
    }, []);

    useEffect(() => {
        getCallLog();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (callLogStatus === "success") {
            const { data: tableData, total } = callLogRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [callLogStatus, callLogRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }


    function openPasswordForm(e) {
        setSelectedCallId(e.currentTarget.getAttribute("id"));
        setPasswordModalVisible(true);
    }

    function closeModel() {
        setPasswordModalVisible(false);
    }

    async function handleSubmit(inputFormData) {
        const formData = { ...inputFormData, staff_id };
        formData.password = encrypt(formData.password);
        setButtonStatus(true);
        const { success, data, message } = await HTTP(
            "/dashboard/getSingleCallLogGuestDetails",
            {
                ...formData,
            },
        );
        setPasswordModalVisible(false);
        if (!success) {
            notification.error({
                message,
            });
        } else {
            setGuestDetails(data[0]);
            setGuestDetailsModalVisible(true);
        }
        setButtonStatus(false);
    }

    function handleGuestModelClose() {
        setGuestDetailsModalVisible(false);
    }

    async function downalodReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getCallLogsDetailsReport", {
            ...tempFormData,
        });
        downloadCSV(res, `calllog_details_reports`);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader showSingleSelect={false}
                    extraAfter={
                        (getUserRole() == "Super Admin" ||
                            getUserRole() == "Admin" ||
                            getUserRole() == "Management") && (
                            <Button
                                type="primary"
                                className="margin-right-5"
                                onClick={downalodReport}
                            >
                                Download
                            </Button>
                        )
                    }
                />
                <Card className="box-shadow margin-10">
                    {callLogStatus !== "loading" && callLogStatus !== "idle" ? (
                        <CustomTable
                            columns={detailsColumn(openPasswordForm)}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            className="callLogsTable"
                            rowKey="id"
                        />
                    ) : (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    )}
                </Card>
            </Card>
            <Modal
                title="Admin Password"
                open={passwordModalVisible}
                footer=""
                onCancel={closeModel}
                destroyOnClose={true}
                className="test"
            >
                <Form
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={handleSubmit}
                    autoComplete="off"
                    initialValues={{ id: selectedCallId }}
                >
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please Input Password!",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Password"
                            type="password"
                            id="password"
                            className="guest-details-input"
                        ></Input>
                    </Form.Item>
                    <Form.Item label="call Id" name="id" className="hidden">
                        <Input
                            id="id"
                            className="guest-details-input"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={buttonStatus}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="Guest Details"
                destroyOnClose={true}
                open={guestDeatilsModalVisible}
                onCancel={handleGuestModelClose}
                onOk={handleGuestModelClose}
            >
                <Form
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    autoComplete="off"
                    initialValues={guestDetails}
                >
                    <Form.Item label="Name" name="guest_name">
                        <Input
                            // placeholder="Name"
                            bordered={false}
                            type="text"
                            id="guest_name"
                            className="guest-details-input"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item label="Phone" name="guest_phone_number">
                        <Input
                            bordered={false}
                            type="text"
                            id="guest_phone_number"
                            className="guest-details-input"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item label="Room no" name="guest_room_number">
                        <Input
                            bordered={false}
                            type="text"
                            id="guest_room_number"
                            className="guest-details-input"
                            disabled
                        ></Input>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default CallLogDetails;